import React, {Component} from 'react'
import PropTypes from "prop-types";
import {authenticationService} from "../../services/AuthenticationService";
import Error from "../single_components/Error";
import SvGraphics from "../../assets/SvGraphics";
import LeumitSelfUpdateFileResponsiveComponent from "./LeumitSelfUpdateFileResponsiveComponent";
import Files from "react-files";
import DoctorApi from "../../services/ApiServices/doctorApi";

class LeumitSelfUpdateFiles extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            fileForms: this.props.fileForms,
            filesErrorOnSave: this.props.filesErrorOnSave,
            otherForms: this.props.otherForms,
            addedFilesList: this.props.addedFilesList,
            selectedCategory: "",
            isMergingFiles:false,
            selectedFile: {},

        }
    }

    componentDidMount() {
        let {selectedCategory} = this.state
        if (!selectedCategory)
            this.saveSelectedCategory('20')
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    saveOtherSelectedFile = (event) => {
        this.setState({selectedFile: event})
    }

    saveSelectedCategory = (event) => {
        this.props.onValueChange("selectFileCategory", event)
        this.setState({selectedCategory: event})
    }

    saveSelectedFile = (selectedFile, index) => (
        this.props.saveSelectedFile(selectedFile, index)
    )
    deleteLeumitUploadedFile = (index, fileIndex, fileName) => (
        this.props.deleteLeumitUploadedFile(index, fileIndex, fileName)
    )

    onFilesChange = async (selectedFile) => {
        let {selectedCategory, otherForms} = this.state
        let addedFilesList = this.props.addedFilesList
        await this.props.addFileObj(addedFilesList.length, selectedCategory, selectedFile)

    }

    getMergedFile = async (filesLinks) => {
        this.setState({isMergingFiles: true})
        try {
            let response = await DoctorApi.downloadAndMergeFiles(filesLinks);
            if (response && response.data) {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const fileExtension = response.headers['content-type'].includes("gzip")?'pdf.gz':"pdf"
                a.download = `merged_files_request_${this.state.entry.RequestID}.${fileExtension}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            } else {
                console.error('No file found in the response data');
            }
            this.setState({isMergingFiles: false})

        } catch (error) {
            console.error('Error downloading or merging the file:', error);
            this.setState({isMergingFiles: false})

        }
    };

    render() {
        let {t, entry, filesErrorOnSave, fileForms} = this.props

        let filesToUpload = this.props.filesToUpload ? this.props.filesToUpload : []
        let filesCompResponsive = []
        let filesLinks = []
        let currentUser = authenticationService.currentUserValue;
        let isDoctor = currentUser ? currentUser.role[0] === "Doctor" : false


        for (let i = 0; i < filesToUpload.length; i++) {
            filesLinks.push(filesToUpload[i].FileUrl)
            filesCompResponsive.push(
                <div key={filesToUpload[i].Form_type_ID}>
                    <LeumitSelfUpdateFileResponsiveComponent
                        Form_type_ID={filesToUpload[i].Form_type_ID}
                        index={i}
                        t={t}
                        isLoading={filesToUpload[i].isLoading}
                        FileUrl={filesToUpload[i].FileUrl}
                        File_Name={filesToUpload[i].File_Name}
                        deleteLeumitUploadedFile={(index, fileIndex, fileName) => this.deleteLeumitUploadedFile(index, fileIndex, fileName)}
                        saveSelectedFile={(selectedFile, index) => this.saveSelectedFile(selectedFile, index)}
                        Form_desc_he={filesToUpload[i].Form_desc}
                        entry={entry}/>
                    <div className={'upload-files-splitter'}/>

                </div>)
        }


        let {selectedCategory, selectedFile, otherForms} = this.state
        let addedFilesList = this.props.addedFilesList

        let language = localStorage.getItem('language')

        let forms = otherForms.map(item => {
                return <option value={item.Form_type_ID}>{language === "he" ? item.Form_desc_he : item.Form_desc}</option>
            }
        )
        let addedFiles = []


        addedFiles = addedFilesList.map((item, index) => {
            filesLinks.push(item.Form_url)

            return (

                <div className={'uploaded-files-view-Block'} key={item.Form_url}>
                    <SvGraphics className={'uploaded-files-label-button-Leumit'}
                                svgname={'pdf-svg'}/>
                    <label
                        className={'uploaded-files-name'}> {language === "he" ? item.Form_type.Form_desc_he : item.Form_type.Form_desc} </label>
                    <a href={item.Form_url} target="_blank"
                       className={'uploaded-files-label-view-Leumit'}> {t('patient_self_boarding.see_file')}</a>

                    <SvGraphics className={'uploaded-files-label-button-Leumit'}
                                onClick={() => this.props.deleteUploadedFile(index)} svgname={'delete-icon'}/>
                </div>


            )
        })


        return (


            <div className={'patientsFormBoxes'}>
                {filesErrorOnSave &&
                    <label className={"error_uploadFiles"}>{t('patient_self_boarding.upload_req_files')}</label>}

                {isDoctor && !this.state.isMergingFiles && <button className={'mergeFiles-button'} onClick={async () => this.getMergedFile(filesLinks)}>אחד את
                    הקבצים</button>}
                {this.state.isMergingFiles && <div className="loader-uploadfiles"/>}


                {filesCompResponsive}
                <div className={'blankSpace'}/>

                <div className={'patientsFormRow'} id={'uploadFile'}>
                    <div className={'fileForms-label-Leumit'}>{t('patient_self_boarding.upload_other_files')}</div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <select className={'selectBox'} id="selectFileCategory" name="selectFileCategory"
                                style={{marginTop: '17px'}}
                                value={selectedCategory ? selectedCategory : '20'}
                                onChange={(event) => this.saveSelectedCategory(event.target.value)}>
                            <option/>
                            {forms}
                        </select>
                    </div>
                    {/*<input className={'chooseFileStyle'} type="file" name="image_uploads" id="file-input"
                           onChange={(event) => this.saveOtherSelectedFile(event.target)}/>
*/}
                    {!this.props.isUploadingFiles && <Files
                        className='UploadFiles-responsive'
                        onChange={this.onFilesChange}
                        maxFiles={15}
                        maxFileSize={1000000000}
                        minFileSize={0}
                        clickable>
                        <div className={"UploadFiles-div-label"}>

                            <SvGraphics className={"uploadFiles-icon"} svgname={'plus-svg'} width={'12px'}
                                        height={'12px'}/>
                            <label className={"uploadFiles-text"}>
                                {t('patient_self_boarding.choose_file')}
                            </label>

                        </div>


                    </Files>}

                    {this.props.isUploadingFiles && <div className="loader-uploadfiles"/>}


                </div>


                {addedFiles}

                <div className={'blankSpace'}/>

                {this.props.docWidth < 1200 && <div className={'patientsFormRow'}>
                    <div className={'next-Tab-Container'}
                         onClick={() => this.props.changeView(4)}> {t('patient_self_boarding.continue_cannabisTab')}</div>
                </div>}


            </div>

        )
    }
}

LeumitSelfUpdateFiles.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default LeumitSelfUpdateFiles;
